import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box, CircularProgress,
    useMediaQuery,
    useTheme,
} from '@mui/material';

type BaseDialogProps = {
    open: boolean;
    onClose: () => void;
    onSave?: () => void;
    disableSave?: boolean;
    title?: string;
    children: React.ReactNode;
    closeOnly?: boolean;
    saving?: boolean;
    maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
};

export default function BaseDialog({
                                       open,
                                       onClose,
                                       onSave,
                                       disableSave = false,
                                       title,
                                       children,
                                       closeOnly = false,
                                       saving = false,
                                       maxWidth = 'sm', // Default to 600px
                                   }: BaseDialogProps) {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth={maxWidth}
            fullScreen={isMobile}
        >
            {title && <DialogTitle>{title}</DialogTitle>}
            <DialogContent>
                <Box mt={1}>{children}</Box>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'flex-end', px: 2, pb: 2 }}>
                {closeOnly ? (
                    <Button onClick={onClose} variant="outlined" autoFocus>
                        Schliessen
                    </Button>
                ) : (
                    <>
                        <Button onClick={onClose} variant="outlined">
                            Abbrechen
                        </Button>
                        <Button
                            onClick={onSave}
                            variant="contained"
                            color="secondary"
                            autoFocus
                            disabled={disableSave}
                            sx={{
                                ml: 2,
                                minWidth: 110,
                                height: 44.5,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                padding: '6px 16px',
                            }}
                        >
                            {saving ? (
                                <CircularProgress size={20} color="inherit" />
                            ) : (
                                'Speichern'
                            )}
                        </Button>
                    </>
                )}
            </DialogActions>
        </Dialog>
    );
}
